module.exports = __webpack_public_path__ + "static/img/junk-scan.6bf9663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/junk-scan.png
// module id = GR7n
// module chunks = 1